<template>
    <fromInputMultiSelectDropdown
        v-on="$listeners"
        :options="apps"
        uniqueId="cvApps"
        :defaultText="defaultText"
        :selectedIds="selectedIds"
        :isDisable="isDisabled"
        :searchFields="['displayText', 'id']"
        :showLeavesBorder="false"
        noResultsIndication="No results found"
        label="Apps"
        preIconKey="icon"
        postIconKey="postIcon"
        :isPostIconFunction="true"
        @selectedItem="updateSelectedItems"
        @unselectedItem="updateSelectedItems"
        @selectAllClicked="updateSelectedItems"
        @closeMenu="closeMenu"
        @openMenu="openMenu"
        ref="fromInputMultiSelectDropdown"
    >
    </fromInputMultiSelectDropdown>
</template>

<script>
import FromInputMultiSelectDropdown from 'components/dropdowns/FromInputMultiSelectDropdown.vue';

const lockIcon = 'lockApp';
const unlockIcon = 'unlockApp';
const lockIconTooltip = 'App is already assigned \nto a different CV map';

export default {
    name: 'AppsDropdown',
    components: { FromInputMultiSelectDropdown },
    props: {
        cvMapId: [Number, String],
        selectedIds: Array,
        isLoading: Boolean,
        options: {
            type: Array,
            default: () => []
        },
        selectedLoaded: Boolean
    },
    data: () => ({
        apps: [],
        currentlySelectedIds: [],
        isMenuOpened: false
    }),
    watch: {
        options: {
            handler(newValue) {
                this.apps = this.formatOptions(newValue);
            },
            immediate: true
        },
        selectedLoaded: {
            handler(newValue) {
                // sort options when selected ids load for the first time
                if (newValue && this.options && this.options.length && this.$refs.fromInputMultiSelectDropdown) {
                    this.$refs.fromInputMultiSelectDropdown.sortOptions();
                }
            },
            immediate: true
        }
    },
    methods: {
        closeMenu() {
            this.isMenuOpened = false;
        },
        openMenu() {
            this.isMenuOpened = true;
            this.currentlySelectedIds = this.selectedIds.slice();
        },
        updateSelectedItems(items) {
            this.currentlySelectedIds = items;
        },
        getLockIcon(app) {
            const selectedIds = this.isMenuOpened ? this.currentlySelectedIds : this.selectedIds;
            if (!app.cvMapId || this.cvMapId === app.cvMapId) return '';
            if (selectedIds.indexOf(app.appKey) > -1) {
                return { icon: unlockIcon, tooltip: '' };
            }
            return { icon: lockIcon, tooltip: lockIconTooltip };
        },
        formatOptions(newValue) {
            if (!newValue) return [];

            return newValue.map((app) => ({
                id: app.appKey,
                displayText: app.name,
                postIcon: ((currApp) => {
                    return () => {
                        return this.getLockIcon(currApp).icon;
                    };
                })(app),
                postIconTooltip: ((currApp) => () => this.getLockIcon(currApp).tooltip)(app),
                icon: app.icon
            }));
        }
    },
    computed: {
        isDisabled() {
            return !this.options || !this.options.length;
        },
        defaultText() {
            if (!this.apps.length && !this.isLoading) {
                return 'No iOS apps';
            }
            if (this.selectedIds.length) {
                return `${this.selectedIds.length} Selected`;
            }
            return 'None';
        }

    }
};
</script>
<style scoped lang="scss">
</style>
